import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus-simple",
  "use": "icon-minus-simple-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" aria-hidden=\"true\" id=\"icon-minus-simple\"><path fill=\"currentColor\" d=\"M5 11h14v2H5v-2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol